import { render, staticRenderFns } from "./deptmanage.vue?vue&type=template&id=7cb40c84&scoped=true&"
import script from "./deptmanage.vue?vue&type=script&lang=js&"
export * from "./deptmanage.vue?vue&type=script&lang=js&"
import style0 from "./deptmanage.vue?vue&type=style&index=0&id=7cb40c84&scoped=true&lang=css&"
import style1 from "./deptmanage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb40c84",
  null
  
)

export default component.exports